import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

interface InitialState {
  deviceList: any;
  loading: boolean;
  configureList:any;
  configureListNew:any;
  deviceWithConfigured:any;
}
const devices =
  { 
    data:[{
      id:'700a0c2a69e62b6c',
      attributes:{
        name:'A', agent_running:'yes', device_online:'',ip_address:'', iccid:''
      },
      relationships:{
        devicegroup:{type:''}
      }
    },{
      id:'700a0c2a69e62bca',
      attributes:{
        name:'B', agent_running:'yes', device_online:'',ip_address:'', iccid:''
      },
      relationships:{
        devicegroup:{type:''}
      }
    },{
      id:'700a0c2a69e635ba',
      attributes:{
        name:'C', agent_running:'yes', device_online:'',ip_address:'', iccid:''
      },
      relationships:{
        devicegroup:{type:''}
      }
    },{
      id:'700a0c2a69e636aa',
      attributes:{
        name:'D', agent_running:'no', device_online:'',ip_address:'', iccid:''
      },
      relationships:{
        devicegroup:{type:''}
      }
    }]
  }

  const Fakedevices =
  { 
    data:[{
      id:' fake_dev_1',
      attributes:{
        name:'Fake Device 1', agent_running:'yes', device_online: true,ip_address:'', iccid:''
      },
      relationships:{
        devicegroup:{type:''}
      }
    },{
      id:'fake_dev_2',
      attributes:{
        name:'Fake Device 2', agent_running:'yes', device_online: true,ip_address:'', iccid:''
      },
      relationships:{
        devicegroup:{type:''}
      }
    },{
      id:'fake_dev_3',
      attributes:{
        name:'Fake Device 3', agent_running:'yes', device_online: true,ip_address:'', iccid:''
      },
      relationships:{
        devicegroup:{type:''}
      }
    },
    {
      id:'fake_dev_4',
      attributes:{
        name:'Fake Device 4', agent_running:'yes', device_online: true,ip_address:'', iccid:''
      },
      relationships:{
        devicegroup:{type:''}
      }
    },
    {
      id:'fake_dev_5',
      attributes:{
        name:'Fake Device 5', agent_running:'yes', device_online: true,ip_address:'', iccid:''
      },
      relationships:{
        devicegroup:{type:''}
      }
    },{
      id:'fake_dev_6',
      attributes:{
        name:'Fake Device 6', agent_running:'yes', device_online: true,ip_address:'', iccid:''
      },
      relationships:{
        devicegroup:{type:''}
      }
    },{
      id:'fake_dev_7',
      attributes:{
        name:'Fake Device 7', agent_running:'yes', device_online: true,ip_address:'', iccid:''
      },
      relationships:{
        devicegroup:{type:''}
      }
    },{
      id:'fake_dev_8',
      attributes:{
        name:'Fake Device 8', agent_running:'yes', device_online: true,ip_address:'', iccid:''
      },
      relationships:{
        devicegroup:{type:''}
      }
    },{
      id:'fake_dev_9',
      attributes:{
        name:'Fake Device 9', agent_running:'yes', device_online: true,ip_address:'', iccid:''
      },
      relationships:{
        devicegroup:{type:''}
      }
    },{
      id:'fake_dev_10',
      attributes:{
        name:'Fake Device 10', agent_running:'yes', device_online: true,ip_address:'', iccid:''
      },
      relationships:{
        devicegroup:{type:''}
      }
    }
  ]
  }


const initialState: InitialState = {
  deviceList: devices,
  loading: false,
  configureList:[],
  configureListNew:[],
  deviceWithConfigured:[]
};

const deviceSlice = createSlice({
  name: "devices",
  initialState,
  reducers: {
    deviceList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      deviceList: action.payload,
    }),
    configureList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      configureList: action.payload,
    }),
    configureListNew: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      configureListNew: action.payload,
    }),
    deviceWithConfigured: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      deviceWithConfigured: action.payload,
    }),

    setLoader: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      loading: action.payload,
    }),
  },
});

export const { deviceList, configureList,configureListNew, deviceWithConfigured, setLoader } = deviceSlice.actions;

export default deviceSlice.reducer;
